import { render, staticRenderFns } from "./VDealLoan.vue?vue&type=template&id=cdf6298e"
import script from "./VDealLoan.vue?vue&type=script&lang=js"
export * from "./VDealLoan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports